// @ts-strict-ignore
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { ArticleInfoVO } from '@project/model/vo/project.vo';
import { Euler, Vector3 } from 'three';
import { Rectangle3D } from '@3d-scene/model/rectangle-3d';

export class CopiedArticleInformation {
  public static readonly QUALIFIED_CLASS_NAME: string = 'CopiedArticleInformation';

  // used during serialization from/to clipboard
  protected readonly qualifiedClassName: string;

  public isDynamic: boolean = false;
  public articleUsage: ArticleUsageVO;
  public dynamicArticleInfo: ArticleInfoVO;
  public dynamicArticleMetaElements: any[];

  public offsetFromCenter: Vector3;
  public rotation: Euler;

  public oldArticleUsageId: string;

  public constructor(qualifiedClassName?: string) {
    this.qualifiedClassName = qualifiedClassName || CopiedArticleInformation.QUALIFIED_CLASS_NAME;
  }

  public get articleUsageId(): string {
    return this.articleUsage.id;
  }

  public get articleUsageGroupId(): string {
    return this.articleUsage.groupId;
  }

  public get requiresAllParentArticlesToBeCopied(): boolean {
    return true;
  }
}

export class CopiedTextureInformation {
  public metaElementName: string;
  public localRectangle: Rectangle3D;
  public distanceToPreviousConnection: number;
}

export class CopiedLabelStripArticleInformation extends CopiedArticleInformation {
  public static readonly QUALIFIED_CLASS_NAME: string = 'CopiedLabelStripArticleInformation';

  public textureConnectionInfos: CopiedTextureInformation[];

  public constructor() {
    super(CopiedLabelStripArticleInformation.QUALIFIED_CLASS_NAME);
  }

  public get requiresAllParentArticlesToBeCopied(): boolean {
    return false;
  }
}
